/**
 * Analytics integration module for Booster Landing Optimizer
 * Supports Google Analytics via dataLayer with test group tracking
 */
import { loadTestGroupStorage, TEST_STORAGE_KEY } from './ab-testing.js';
function initializeDataLayer() {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
}
function gtag(..._args) {
    initializeDataLayer();
    window.dataLayer.push(arguments);
}
export function setGoogleAnalyticsUserProperties() {
    if (!window.localStorage) {
        return;
    }
    try {
        initializeDataLayer();
        const storage = loadTestGroupStorage();
        // Format test group assignments as "testname:group" pairs
        const testGroupString = Array.from(Object.entries(storage))
            .map(([name, item]) => `${name}:${item?.group ?? 'unknown'}`)
            .join(',');
        // Set user properties using gtag
        gtag('set', 'user_properties', {
            [TEST_STORAGE_KEY]: testGroupString || 'none'
        });
    }
    catch (error) {
        // Silent fail
    }
}
export function initializeAnalytics(config) {
    if (!config.enabled) {
        return;
    }
    try {
        initializeDataLayer();
        gtag('js', new Date());
    }
    catch (error) {
        // Silent fail
    }
}
//# sourceMappingURL=google-analytics.js.map